// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { url,logout } from '../components/helper'
// import { Loader } from 'react-overlay-loader';
// import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// class CreateBranch extends Component{
//     constructor(props){
//         super(props)

//         this.state={
//             section:2,
//             loading:true,
//             btn_disabled:true,
//             nameErrorHidden:true,
//             runIPErrorHidden:true,
//             runIPMissingErrorHidden:true,
//             userIPErrorHidden:true,
//             options_organization:[],
//             organization:null,
//             message_type:1,
//             message_title:"",
//             message_body:"",
//             message_box_open:false
//         }

//         this.validateName = this.validateName.bind(this)
//         this.handleOrganizationSelect = this.handleOrganizationSelect.bind(this)
//         this.enable_btn = this.enable_btn.bind(this)
//         this.create_branch = this.create_branch.bind(this)
//         this.close_message_box_modal = this.close_message_box_modal.bind(this)
//         this.validateRIP.bind(this)
//         this.validateUIP.bind(this)
//     }

//     componentWillMount = () =>{
//         var cookies = new Cookies();
//         var loginStatus = cookies.get('loggedIn')
//         if (loginStatus === undefined) {
//             window.location = '/login'
//         }
//         var branch_admin = cookies.get('branch-admin')
//         if(branch_admin === 'true'|| cookies.get('branch-user') === "true"){
//             window.location = '/dashboard'
//         }
//         this.setState({
//             loading:true
//         })
//         var dashboar_ref = this
//         var http = new XMLHttpRequest();
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         http.open('GET', url+'/api/questions/wizard/organisation?user_id=' + user_id, true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.send()
//         http.onreadystatechange = function () {
//             //(http.responseText)
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                     if (json.status === 200) {
//                         var orgs = []
//                         json.organisations.forEach(element => {
//                             var temp = {
//                                 value: element.org_name, label: element.org_name, id: element.org_id
//                             }
//                             orgs.push(temp)
//                             //(orgs)
//                         });
//                         dashboar_ref.setState({
//                             options_organization: orgs,
//                             loading:false
//                         })
//                     }
//                 }

//     }
// }
//     validateName = ()=>{
//         var input = document.getElementById("branchName").value
//         //(input)
//         if(input === ''){
//             this.setState({
//                 nameErrorHidden:false
//             },this.enable_btn)
//         }
//         else{
//             this.setState({
//                 nameErrorHidden:true
//             },this.enable_btn)
//         }
//     }

//     enable_btn = () => {
//         var input = document.getElementById("branchName").value
//         if (this.state.organization != null & input!=='') {
//             this.setState({
//                 btn_disabled: false
//             })
//         }
//         else{
//             this.setState({
//                 btn_disabled: true
//             })
//         }
//     }

//     handleOrganizationSelect = (organization) => {
//         this.setState({ organization}, this.enable_btn);
//     }

//     close_message_box_modal = () => {

//         if(this.state.message_type ===1){
//             this.setState({
//                 message_box_open: !this.state.message_box_open,
//                 loading: false
//             })
//             window.location = '/create-branch'
//         }
//         if(this.state.message_type === 2){
//             this.setState({
//                 message_box_open: !this.state.message_box_open,
//                 loading: false
//             })
//         }
//     }

//     create_branch = () =>{
//         var cookies = new Cookies();
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         var dashboar_ref = this
//         if(this.state.runIPErrorHidden === false ){
//             this.setState({
//                 message_title:"Incorrect IP",
//                 message_body:"Please enter correct IP address Run server",
//                 message_type:2,
//                 message_box_open:true
//             })
//             return
//         }
//         if(this.state.userIPErrorHidden === false){
//             this.setState({
//                 message_title:"Incorrect IP",
//                 message_body:"Please enter correct IP address for photo server",
//                 message_type:2,
//                 message_box_open:true
//             })
//             return
//         }

//         var branch_name = document.getElementById("branchName").value
//         var branch_address = document.getElementById("branchAddress").value
//         var api_server_ip = document.getElementById("APIServerIP").value
//         var photo_upload_ip = document.getElementById("PhotoUploadIP").value
//         var photo_upload_user = document.getElementById("PhotoUploaduser").value
//         var photo_upload_password = document.getElementById("PhotoUploadPassword").value
//         var photo_upload_directory = document.getElementById("PhotoUploadInitialDirectory").value
//         var longitude = document.getElementById("Longitude").value
//         var Latitude = document.getElementById("Latitude").value
//         if(api_server_ip === ""){
//             this.setState({
//                 runIPMissingErrorHidden:false
//             })
//             return
//         }
//         else{
//             this.setState({
//                 runIPMissingErrorHidden:true
//             })
//         }
//         this.setState({loading:true})
//         var arg_list = '&org_id='+this.state.organization.id+'&user_id='+user_id+'&branch_name='+branch_name+'&branch_address='+branch_address+'&api_server_ip='+api_server_ip
//                         +'&photo_upload_ip='+photo_upload_ip+'&photo_upload_user='+photo_upload_user+'&photo_upload_password='+photo_upload_password
//                         +'&photo_upload_directory='+photo_upload_directory+'&branch_longitude='+longitude+'&branch_latitude='+Latitude
//                         //+'&gps_location='+gps_location
//         var http = new XMLHttpRequest()
//         http.open('POST',url+'/api/branch', true)
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         //(arg_list)
//         http.send(arg_list)
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 //(json)
//                 if(json.status === 200){
//                     dashboar_ref.setState({
//                         message_title:"Branch created",
//                         message_body:"Branch has been created cuccessfully",
//                         message_type:1,
//                         message_box_open:true
//                     })
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         message_title:"Failure",
//                         message_body:"Branch could not be created",
//                         message_type:2,
//                         message_box_open:true
//                     })
//                 }
//             }
//             if(http.readyState === 4 && http.status === 401){
//                 logout()
//             }

//         }
//         http.onerror = function(){
//             dashboar_ref.setState({
//                 message_title:"Failure",
//                 message_body:"Branch could not be created",
//                 message_type:2,
//                 message_box_open:true
//             })
//         }
//         http.ontimeout = function(){
//             dashboar_ref.setState({
//                 message_title:"Timeout",
//                 message_body:"Request has timed out. Try again",
//                 message_type:2,
//                 message_box_open:true
//             })
//         }
//     }

//     validateRIP = () =>{
//         var input = document.getElementById("APIServerIP").value
//         //(input)
//         if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(input)){
//             //("correct")
//             this.setState({
//                 runIPErrorHidden:true
//             })
//         }
//         else{
//             this.setState({
//                 runIPErrorHidden:false
//             })
//         }
//     }
//     validateUIP = () =>{
//         var input = document.getElementById("PhotoUploadIP").value
//         //(input)
//         if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(input)){
//             //("correct")
//             this.setState({
//                 userIPErrorHidden:true
//             })
//         }
//         else{
//             this.setState({
//                 userIPErrorHidden:false
//             })
//         }
//     }
//     render(){
//         if(this.state.section === 1){
//             return(
//                 <div>
//                    <Loader loading={this.state.loading} fullPage={true} />
//                 </div>
//             )
//         }
//         if(this.state.section === 2){
//            return(
//             <div>
//                 <Modal isOpen={this.state.message_box_open}>
//             <ModalHeader>
//             {this.state.message_title}
//             </ModalHeader>
//             <ModalBody>
//                  <b>{this.state.message_body}</b>
//             </ModalBody>
//             <ModalFooter>
//                  <Button color="primary" onClick={this.close_message_box_modal}>Close</Button>
//             </ModalFooter>
//                 </Modal>

//             <Loader loading={this.state.loading} fullPage={true} />
//             <div className="clearfix" id="page-header">
//                 <div>
//                     <Header />
//                 </div>
//             </div>

//             <div >
//                 <SideBar isActive="branch"/>
//             </div>

//             <div id="page-content-wrapper" className="rm-transition">
//             <div id="page-content">

//             <div className="row">
//             <div className="col-md-2"></div>
//             <div className="col-md-8">
//             <h2 style={{textAlign:"center"}}>Create Branch</h2>
//             </div>
//             <div className="col-md-2"></div>
//             </div>
//             <div className="row">
//             <div className="col-md-2"></div>
//             <div className="col-md-8">
//             <form>
//                     <div className="form-group">
//                         <label for="branchName"><b>Name</b></label>
//                         <input type="text" className="form-control" id="branchName" placeholder="Enter Branch Name" onBlur={this.validateName} maxLength="40"></input>
//                         <div class="isa_error" hidden={this.state.nameErrorHidden}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>You need to provide name to create a branch</b>
//                             </div>
//                     </div>

//                     <div className="form-group">
//                     <label ><b>Select Organization</b></label>
//                     <SelectList options={this.state.options_organization} actionHandler={this.handleOrganizationSelect} selectedOption={this.state.organization} />
//                     </div>

//                     <div className="form-group">

//                         <label for="branchAddress"><b>Address</b></label>
//                         <input type="text" className="form-control" id="branchAddress" placeholder="Enter Branch Address" ></input>
//                     </div>

//                      {/* <div className="form-group">
//                         <label for="GPSLocation"><b>GPS location</b></label>
//                         <input type="text" className="form-control" id="GPSLocation" placeholder="Enter Branch GPS location"></input>
//                     </div> */}
//                     <div className="form-group">
//                         <label><b>GPS location</b></label>
//                        <div className="row">
//                        <div className="col-md-6">
//                        <div className="form-group">
//                         <label for="GPSLocation"><b>Longitude</b></label>
//                         <input type="text" className="form-control" id="Longitude" placeholder="Enter Branch GPS location" maxLength="40"></input>
//                     </div>
//                        </div>
//                     <div className="col-md-6">
//                     <div className="form-group">
//                         <label for="GPSLocation"><b>Latitude</b></label>
//                         <input type="text" className="form-control" id="Latitude" placeholder="Enter Branch GPS location" maxLength="40"></input>
//                     </div>
//                     </div>
//                        </div>
//                     </div>

//                     <div className="form-group">
//                         <label for="APIServerIP"><b>API Server IP</b></label>
//                         <input type="text" className="form-control" id="APIServerIP" placeholder="Enter Branch API Server IP" maxLength="40" onBlur={this.validateRIP}></input>
//                         <div class="isa_error" hidden={this.state.runIPErrorHidden}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>IP is not correct</b>
//                             </div>
//                         <div class="isa_error" hidden={this.state.runIPMissingErrorHidden}>
//                             <i class="fa fa-times-circle"></i>
//                             <b>Please Enter Runsheet Server IP</b>
//                         </div>
//                     </div>

//                     <div className="form-group">
//                         <label for="PhotoUploadIP"><b>Photo Upload IP</b></label>
//                         <input type="text" className="form-control" id="PhotoUploadIP" placeholder="Enter Branch Photo Upload IP" maxLength="40" onBlur={this.validateUIP}></input>
//                         <div class="isa_error" hidden={this.state.userIPErrorHidden}>
//                                 <i class="fa fa-times-circle"></i>
//                                 <b>IP is not correct</b>
//                             </div>
//                     </div>

//                     <div className="form-group">
//                         <label for="PhotoUploaduser"><b>Photo Upload User</b></label>
//                         <input type="text" className="form-control" id="PhotoUploaduser" placeholder="Enter Branch Photo Upload User" maxLength="40"></input>
//                     </div>

//                     <div className="form-group">
//                         <label for="PhotoUploadPassword"><b>Photo Upload Password</b></label>
//                         <input type="text" className="form-control" id="PhotoUploadPassword" placeholder="Enter Branch Photo Upload Password" maxLength="40" ></input>
//                     </div>

//                     <div className="form-group">
//                         <label for="PhotoUploadInitialDirectory"><b>Photo Upload Initial Directory</b></label>
//                         <input type="text" className="form-control" id="PhotoUploadInitialDirectory" placeholder="Enter Branch Photo Upload Initial Directory" ></input>
//                     </div>
//                     <button type="button" className="btn btn-block btn-primary" max-width='100%' disabled={this.state.btn_disabled} onClick={this.create_branch}>Create Branch</button>

//                 </form>
//             </div>
//             <div className="col-md-2"></div>
//             </div>
//             </div>
//             </div>
//         </div>
//            )
//         }
//     }
// }

// export default CreateBranch

import React from 'react'
import { Loader } from 'react-overlay-loader'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Cookies from 'universal-cookie'
import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { logout, url } from '../components/helper'

const CreateBranch = () => {
    const [section, setSection] = React.useState(2)
    const [loading, setLoading] = React.useState(true)
    const [btnDisabled, setBtnDisabled] = React.useState(true)
    const [nameErrorHidden, setNameErrorHidden] = React.useState(true)
    const [runIpErrorHidden, setRunIpErrorHidden] = React.useState(true)
    const [runIpMissingErrorHidden, setRunIpMissingErrorHidden] =
        React.useState(true)
    const [userIpErrorHidden, setUserIpErrorHidden] = React.useState(true)
    const [optionsOrganization, setOptionsOrganization] = React.useState([])
    const [organization, setOrganization] = React.useState(null)
    const [messageType, setMessageType] = React.useState(1)
    const [messageTitle, setMessageTitle] = React.useState('')
    const [messageBody, setMessageBody] = React.useState('')
    const [messageBoxOpen, setMessageBoxOpen] = React.useState(false)

    //Validates the name is correct
    const validateName = () => {
        const input = document.getElementById('branchName').value
        setNameErrorHidden(input !== '')
        enableBtn()
    }

    //Sets the target organization on selections
    const handleOrganizationSelect = (organization) => {
        setOrganization(organization)
        enableBtn()
    }

    //Enables the Create Branch Button
    const enableBtn = () => {
        const input = document.getElementById('branchName').value
        setBtnDisabled(organization === null && input === '')
    }

    //Closes the message box modal
    const closeMessageBoxModal = () => {
        setMessageBoxOpen(!messageBoxOpen)
        setLoading(messageType !== 1 && messageType !== 2)
        if (messageType === 1) {
            window.location = '/create-branch'
        }
    }

    //Validate and set API Server IP
    const validateRIP = () => {
        const input = document.getElementById('APIServerIP').value
        const re_IP = new RegExp(
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
        )
        setRunIpErrorHidden(re_IP.test(input))
    }

    //Validate and set Photo Upload IP
    const validateUIP = () => {
        const input = document.getElementById('PhotoUploadIP').value
        const re_IP = new RegExp(
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
        )
        setUserIpErrorHidden(re_IP.test(input))
    }

    //Pre check on current user credentials
    const credentialCheck = () => {
        const cookies = new Cookies()

        const token = cookies.get('token')
        if (!token) {
            window.location = '/login'
        }
        const branchAdmin = cookies.get('branch-admin')
        const branchUser = cookies.get('branch-user')
        if (branchAdmin === 'true' || branchUser === 'true') {
            window.location = '/dashboard'
        }
        setLoading(true)
    }

    //Getting organisations for the drop down
    const getWizardOrganisation = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/organisation?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let orgs = []
                    data.organisations.forEach((org) => {
                        const org_details = {
                            value: org.org_name,
                            label: org.org_name,
                            id: org.org_id,
                        }
                        orgs.push(org_details)
                    })
                    setOptionsOrganization(orgs)
                    setLoading(false)
                    break
                default:
                    console.error('Invalid data:', data)
                    break
            }
        } catch (err) {
            console.error('Error:', err)
        }
    }

    //Run once on the initial render
    React.useEffect(() => {
        credentialCheck()
        getWizardOrganisation()
    }, [])

    const FormBuilder = (dict) => {
        const data = new URLSearchParams()
        for (const [key, value] of Object.entries(dict)) {
            data.append(key, value)
        }
        return data
    }

    //Execute branch creation
    const createBranch = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        if (!runIpErrorHidden) {
            setMessageTitle('Incorrect IP')
            setMessageBody('Please enter correct IP address Run server')
            setMessageType(2)
            setMessageBoxOpen(true)
            return
        }

        if (!userIpErrorHidden) {
            setMessageTitle('Incorrect IP')
            setMessageBody('Please enter correct IP address for photo server')
            setMessageType(2)
            setMessageBoxOpen(true)
            return
        }

        const branchName = document.getElementById('branchName').value
        const branchAddress = document.getElementById('branchAddress').value
        const apiServerIp = document.getElementById('APIServerIP').value
        const photoUploadIp = document.getElementById('PhotoUploadIP').value
        const photoUploadUser = document.getElementById('PhotoUploaduser').value
        const photoUploadPassword = document.getElementById(
            'PhotoUploadPassword'
        ).value
        const photoUploadDirectory = document.getElementById(
            'PhotoUploadInitialDirectory'
        ).value
        const longitude = document.getElementById('Longitude').value
        const latitude = document.getElementById('Latitude').value

        setRunIpMissingErrorHidden(!apiServerIp)
        setLoading(true)

        //Body

        const branch_details = {
            org_id: organization.id.toString(),
            user_id: userId.toString(),
            branch_name: branchName,
            branch_address: branchAddress,
            api_server_ip: apiServerIp,
            photo_upload_ip: photoUploadIp,
            photo_upload_user: photoUploadUser,
            photo_upload_password: photoUploadPassword,
            photo_upload_directory: photoUploadDirectory,
            branch_longitude: longitude.toString(),
            branch_latitude: latitude.toString(),
        }

        // const argList =
        //     '&org_id=' +
        //     organization.id +
        //     '&user_id=' +
        //     userId +
        //     '&branch_name=' +
        //     branchName +
        //     '&branch_address=' +
        //     branchAddress +
        //     '&api_server_ip=' +
        //     apiServerIp +
        //     '&photo_upload_ip=' +
        //     photoUploadIp +
        //     '&photo_upload_user=' +
        //     photoUploadUser +
        //     '&photo_upload_password=' +
        //     photoUploadPassword +
        //     '&photo_upload_directory=' +
        //     photoUploadDirectory +
        //     '&branch_longitude=' +
        //     longitude +
        //     '&branch_latitude=' +
        //     latitude
        // console.log('branch_details', branch_details)
        const options = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: FormBuilder(branch_details),
        }

        try {
            const res = await fetch(
                `${url}/api/branch?user_id=${userId}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setMessageTitle('Branch created')
                    setMessageBody('Branch has been created successfully')
                    setMessageType(1)
                    setMessageBoxOpen(true)
                    break
                case 401:
                    logout()
                    break
                default:
                    setMessageTitle('Failure')
                    setMessageBody('Branch could not be created')
                    setMessageType(2)
                    setMessageBoxOpen(true)
                    break
            }
        } catch (err) {}
    }

    return (
        <div>
            {section === 1 ? (
                <div>
                    <Loader loading={loading} fullPage={true} />
                </div>
            ) : (
                <div></div>
            )}

            {section === 2 ? (
                <div>
                    <Modal isOpen={messageBoxOpen}>
                        <ModalHeader>{messageTitle}</ModalHeader>
                        <ModalBody>
                            <b>{messageBody}</b>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="primary"
                                onClick={closeMessageBoxModal}
                            >
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>

                    <Loader loading={loading} fullPage={true} />
                    <div className="clearfix" id="page-header">
                        <div>
                            <Header />
                        </div>
                    </div>

                    <div>
                        <SideBar isActive="branch" />
                    </div>

                    <div id="page-content-wrapper" className="rm-transition">
                        <div id="page-content">
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8">
                                    <h2 style={{ textAlign: 'center' }}>
                                        Create Branch
                                    </h2>
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8">
                                    <form>
                                        <div className="form-group">
                                            <label for="branchName">
                                                <b>Name</b>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="branchName"
                                                placeholder="Enter Branch Name"
                                                onBlur={validateName}
                                                maxLength="40"
                                            ></input>
                                            <div
                                                class="isa_error"
                                                hidden={nameErrorHidden}
                                            >
                                                <i class="fa fa-times-circle"></i>
                                                <b>
                                                    You need to provide name to
                                                    create a branch
                                                </b>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label>
                                                <b>Select Organization</b>
                                            </label>
                                            <SelectList
                                                options={optionsOrganization}
                                                actionHandler={
                                                    handleOrganizationSelect
                                                }
                                                selectedOption={organization}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label for="branchAddress">
                                                <b>Address</b>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="branchAddress"
                                                placeholder="Enter Branch Address"
                                            ></input>
                                        </div>

                                        <div className="form-group">
                                            <label>
                                                <b>GPS location</b>
                                            </label>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label for="GPSLocation">
                                                            <b>Longitude</b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="Longitude"
                                                            placeholder="Enter Branch GPS location"
                                                            maxLength="40"
                                                        ></input>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label for="GPSLocation">
                                                            <b>Latitude</b>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="Latitude"
                                                            placeholder="Enter Branch GPS location"
                                                            maxLength="40"
                                                        ></input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label for="APIServerIP">
                                                <b>API Server IP</b>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="APIServerIP"
                                                placeholder="Enter Branch API Server IP"
                                                maxLength="40"
                                                onBlur={validateRIP}
                                            ></input>
                                            <div
                                                class="isa_error"
                                                hidden={runIpErrorHidden}
                                            >
                                                <i class="fa fa-times-circle"></i>
                                                <b>IP is not correct</b>
                                            </div>
                                            <div
                                                class="isa_error"
                                                hidden={runIpMissingErrorHidden}
                                            >
                                                <i class="fa fa-times-circle"></i>
                                                <b>
                                                    Please Enter Runsheet Server
                                                    IP
                                                </b>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label for="PhotoUploadIP">
                                                <b>Photo Upload IP</b>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="PhotoUploadIP"
                                                placeholder="Enter Branch Photo Upload IP"
                                                maxLength="40"
                                                onBlur={validateUIP}
                                            ></input>
                                            <div
                                                class="isa_error"
                                                hidden={userIpErrorHidden}
                                            >
                                                <i class="fa fa-times-circle"></i>
                                                <b>IP is not correct</b>
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label for="PhotoUploaduser">
                                                <b>Photo Upload User</b>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="PhotoUploaduser"
                                                placeholder="Enter Branch Photo Upload User"
                                                maxLength="40"
                                            ></input>
                                        </div>

                                        <div className="form-group">
                                            <label for="PhotoUploadPassword">
                                                <b>Photo Upload Password</b>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="PhotoUploadPassword"
                                                placeholder="Enter Branch Photo Upload Password"
                                                maxLength="40"
                                            ></input>
                                        </div>

                                        <div className="form-group">
                                            <label for="PhotoUploadInitialDirectory">
                                                <b>
                                                    Photo Upload Initial
                                                    Directory
                                                </b>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="PhotoUploadInitialDirectory"
                                                placeholder="Enter Branch Photo Upload Initial Directory"
                                            ></input>
                                        </div>
                                        <button
                                            type="button"
                                            className="btn btn-block btn-primary"
                                            max-width="100%"
                                            disabled={btnDisabled}
                                            onClick={createBranch}
                                        >
                                            Create Branch
                                        </button>
                                    </form>

                                    <div className="col-md-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
        </div>
    )
}

export default CreateBranch

/**
 * Notes
 * - Enable button and validatename should be combined
 * - How does handleOrganizationSelect work?
 * - ValidateUIP and validateRIP can be combined
 * - Need testing
 * - Error bar before redirecting
 */



// WEBPACK FOOTER //
// src/Routes/CreateBranch.js